module.exports = __webpack_public_path__ + "img/f42.e5c551e0.png";